export default {
    MainData: {
        errno: 0,
        errstr: 'success',
        data: {
            topPart: [
                {
                    tabDe: {
                        icon: '',
                        width: '',
                        height: ''
                    },
                    tabAc: {
                        icon: '',
                        width: '',
                        height: ''
                    },
                    list: [
                        {
                            imgUrl: 'https://cjh-amis.cdn.bcebos.com/2021-7/1626785092977/3181.png',
                            jumpUrl: '',
                            uid: ''
                        },
                        {
                            imgUrl: 'https://cjh-amis.cdn.bcebos.com/2021-7/1626785092977/3181.png',
                            jumpUrl: '',
                            uid: ''
                        },
                        {
                            imgUrl: 'https://cjh-amis.cdn.bcebos.com/2021-7/1626785092977/3181.png',
                            jumpUrl: '',
                            uid: ''
                        },
                        {
                            imgUrl: 'https://cjh-amis.cdn.bcebos.com/2021-7/1626785092977/3181.png',
                            jumpUrl: '',
                            uid: ''
                        },
                        {
                            imgUrl: 'https://cjh-amis.cdn.bcebos.com/2021-7/1626785092977/3181.png',
                            jumpUrl: '',
                            uid: ''
                        },
                        {
                            imgUrl: 'https://cjh-amis.cdn.bcebos.com/2021-7/1626785092977/3181.png',
                            jumpUrl: '',
                            uid: ''
                        },
                        {
                            imgUrl: 'https://cjh-amis.cdn.bcebos.com/2021-7/1626785092977/3181.png',
                            jumpUrl: '',
                            uid: ''
                        },
                        {
                            imgUrl: 'https://cjh-amis.cdn.bcebos.com/2021-7/1626785092977/3181.png',
                            jumpUrl: '',
                            uid: ''
                        }
                    ]
                }
            ],
            mingCunList: [
                {
                    imgUrl: 'https://cjh-amis.cdn.bcebos.com/2021-7/1626785092977/3181.png',
                    jumpUrl: '',
                    uid: ''
                },
                {
                    imgUrl: 'https://cjh-amis.cdn.bcebos.com/2021-7/1626785092977/3181.png',
                    jumpUrl: '',
                    uid: ''
                }
            ]
        }
    }
};
